<template>
  <div class="wrapper-overlay">
    <div class="startup-screen" v-if="!is_activating">
      <div class="screen-one">
        <h1 class="greatings" v-if="instructor_info">
          Hello
          {{ instructor_info.first_name + " " + instructor_info.last_name }}
        </h1>
        <h2 class="school-name">
          Welcome to <span class="bold"> {{ $route.query.name }}</span>
        </h2>
        <h4 class="information">
          A few steps are required to activate your account as Manager at
          <span class="bold"> {{ $route.query.name }}</span>,
        </h4>
        <p class="call-action">use the button below to get started</p>
      </div>
      <div class="wizard-option">
        <button @click="activateAccount()" class="btn-activation">
          <span>Activate account</span>
        </button>
      </div>
    </div>

    <!-- Form -->
    <div class="form-widget" v-else>
      <div class="form-header">
        <h2>Create Password</h2>
      </div>
      <div class="form-body">
        <div class="input-group">
          <label>Email</label>
          <input v-model="form.email" type="text" class="text-input" />
        </div>
        <div class="input-group">
          <label>Create Password</label>
          <input v-model="form.password" type="password" class="text-input" />
        </div>
        <div class="input-group">
          <label>Confirm Password</label>
          <input v-model="form.re_password" type="password" class="text-input" />
        </div>
      </div>
      <div class="form-footer">
        <c-button :loading="submit_loading" @click="submitAccount()" class="btn-save">Proceed</c-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "invitation-wizard",
  components: {},
  data() {
    return {
      is_activating: false,
      submit_loading: false,
      form: {
        token: null,
        id: null,
        email: "",
        password: "",
        re_password: "",
      },
      instructor_info: null,
    };
  },
  watch: {},
  mounted() {
    let vm = this;
    vm.form.token = vm.$route.params.token;
    vm.getUserInfo(vm.form.token);
  },
  methods: {
    getUserInfo(token) {
      let vm = this;
      vm.$store
        .dispatch("GET_SCHOOL_MEMBER_ACCOUNT_INFO", { token: token })
        .then((response) => {
          vm.instructor_info = response.data;
          vm.form.id = response.data.id;
          vm.form.email = response.data.email;
        })
        .catch((error) => { });
    },
    submitAccount() {
      let vm = this;
      if (vm.form.password === vm.form.re_password) {
        vm.submit_loading = true;
        vm.$store
          .dispatch("INSTRUCTOR_SUBMIT_ACCOUNT", vm.form)
          .then((response) => {
            vm.submit_loading = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Message",
              text: "Now you can login to your account",
            });
            setTimeout(() => {
              vm.$router.push({ name: "login", query: { school: "exist" } });
            }, 2000);
          })
          .catch((error) => {
            vm.submit_loading = false;
          });
      } else {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "Something wrong",
          text: "Password does not match",
        });
      }
    },
    activateAccount() {
      let vm = this;
      vm.is_activating = true;
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.wrapper-overlay {
  display: block;
  padding-top: 200px;
  background: #ededed;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow-y: auto;

  .startup-screen {
    width: 700px;
    margin: 0 auto;
    min-height: 400px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px 30px;
    background: #0884af;

    .screen-one {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .greatings {
        font-size: 37px;
        color: #fff;
      }

      .school-name {
        color: rgb(241, 239, 239);
        font-size: 40px;

        .bold {
          color: #fff;
          font-weight: 900;
        }
      }

      .information {
        color: #e7e7e7;
        padding: 10px 0px;
        font-size: 20px;
        text-align: center;
        margin-bottom: 10px;

        .bold {
          color: #fff;
          font-weight: 900;
        }
      }

      .call-action {
        font-size: 16px;
        color: #e7e7e7;
      }
    }

    .wizard-option {
      display: flex;
      flex-direction: column;

      .btn-get-started {
        border-radius: 5px;
        color: #1ba5a4;
        background: #fff;
        height: 43px;
        width: 182px;
        margin-bottom: 11px;
      }

      .btn-activation {
        border-radius: 5px;
        color: #1ba5a4;
        background: #fff;
        height: 43px;
        width: 182px;
        margin-bottom: 11px;
      }
    }
  }

  .form-widget {
    width: 400px;
    margin: 0 auto;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 40px 40px;
    background: #fff;

    .form-header {
      padding-bottom: 10px;

      h2 {
        margin: 0px;
        font-weight: 800;
      }
    }

    .form-body {
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;

      .input-group {
        display: flex;
        flex-direction: column;
        margin-block-start: 15px;

        .text-input {
          height: 45px;
          border-radius: 5px;
          border: 1px solid #ddd;
          outline: none;
          padding: 0px 15px;
        }
      }
    }

    .form-footer {
      .btn-save {
        border-radius: 5px;
        color: #fff;
        background: #229ea5;
        height: 43px;
        width: 182px;
        margin-bottom: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}</style>
